import Guid from '_shared/guids/guid';

export default class ForumSubscriberInvitationCommand {
  public inviteeId: string;
  public invitationMessage?: string;

  public constructor(inviteeId: Guid, invitationMessage?: string) {
    if (!inviteeId || inviteeId.isEmpty) throw new Error("Invitee is required.");
    if (invitationMessage !== undefined && invitationMessage.trim().length === 0) {
      throw new Error("Invitation message cannot be blank.");
    }
    this.inviteeId = inviteeId.value;
    this.invitationMessage = invitationMessage?.trim() || undefined;
  }
};
